import { render, staticRenderFns } from "./VendorCompItemList.vue?vue&type=template&id=6845e6c4"
import script from "./VendorCompItemList.vue?vue&type=script&lang=js"
export * from "./VendorCompItemList.vue?vue&type=script&lang=js"
import style0 from "./VendorCompItemList.vue?vue&type=style&index=0&id=6845e6c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports